import React from 'react';
import { Box, TextField, FormControlLabel, Checkbox, Alert, Typography } from '@mui/material';

import { MethodEditorProps } from '../types';

export const LoadCausesEditor: React.FC<MethodEditorProps> = ({ payload, onChange }) => {
  const waitForCompletion = payload?.waitForCompletion !== false;

  return (
    <Box>
      <TextField
        fullWidth
        value={payload?.sdgsOutputPath || 'sdgs'}
        onChange={(e) => onChange({ ...payload, sdgsOutputPath: e.target.value })}
        label="SDGs Output Path"
        placeholder="sdgs"
        helperText="Context path where SDG causes will be stored"
        margin="normal"
      />
      <TextField
        fullWidth
        value={payload?.categoriesOutputPath || 'categories'}
        onChange={(e) => onChange({ ...payload, categoriesOutputPath: e.target.value })}
        label="Categories Output Path"
        placeholder="categories"
        helperText="Context path where category causes will be stored"
        margin="normal"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={payload?.waitForCompletion !== false}
            onChange={(e) => onChange({ ...payload, waitForCompletion: e.target.checked })}
          />
        }
        label="Wait for loading to complete"
        sx={{ mt: 1, mb: 2 }}
      />

      {!waitForCompletion && (
        <Alert severity="warning" sx={{ mt: 2 }}>
          <Typography variant="body2">
            <strong>Warning:</strong> Loading will continue in background. Ensure subsequent steps
            include a delay or use &quot;Wait for Context&quot; method to avoid accessing incomplete
            data.
          </Typography>
        </Alert>
      )}

      <Alert severity="info" sx={{ mt: 2 }}>
        <Typography variant="body2">
          <strong>Output:</strong> Loads all causes and filters them into SDGs and Categories
          <br />
          <strong>SDGs:</strong> Array of SDG objects with id, name, description, and number
          <br />
          <strong>Categories:</strong> Array of category objects with id, name, and description
          <br />
          <strong>Wait Option:</strong> When unchecked, continues flow immediately while loading in
          background
        </Typography>
      </Alert>
    </Box>
  );
};
